<div class="popup__wrap">
  <div class="popup">
    <div class="content">
      <p class="title">Zaznacz swoją rolę:</p>
      <div class="answers">
        <div class="check-button">
          <button (click)="selection_clicked(true)">Jestem listonoszem</button>
<!--          <label for="listonosz">Jestem listonoszem</label>-->
<!--          <input type="radio" id="listonosz">-->
        </div>
        <div class="check-button">
<!--          <label for="pracownik">Jestem pracownikiem obsługi okienka</label>-->
<!--          <input type="radio" id="pracownik">-->
          <button (click)="selection_clicked(false)">Jestem pracownikiem obsługi okienka</button>
        </div>
      </div>
    </div>
  </div>
</div>
